<template>
    <div>
        <v-toolbar dense class="mb-3 secondary" elevation="1" rounded>
            <v-breadcrumbs large :items="[
                { text: 'Sales and Distribution' },
                { text: 'Reports' },
                { text: 'Customers Balance' },
            ]"> </v-breadcrumbs>
        </v-toolbar>
        <v-sheet elevation="1" rounded>
            <v-toolbar flat class="secondary">
                <v-toolbar-title v-if="params.type == 'UNEARNED'">
                    Customers Summary - Unearned Revenue
                </v-toolbar-title>
                <v-toolbar-title v-else-if="params.type == 'RECEIVABLE'">
                    Customers Summary - Under Collection
                </v-toolbar-title>
                <v-toolbar-title v-else>
                    Customers Summary
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <span class="mx-2">
                    Minimum Balance
                    {{formatNumber(params.min_amount)}}
                </span>
                <v-divider vertical></v-divider>
                <v-toolbar-items>
                    <v-btn icon @click="run" :loading="loading">
                        <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                    <v-btn depressed color="primary" @click="searchDialog = true">
                        <v-icon left>mdi-magnify</v-icon>
                        search
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-divider></v-divider>
            <CustomersBalanceReportTable/>
        </v-sheet>
        <v-dialog v-model="searchDialog" width="400">
            <v-card>
                <v-card-title>
                    Search
                </v-card-title>
                <v-card-text>
                    <v-form ref="form">
                        <v-row>
                            <v-col>
                                <PDatePicker
                                    label="As of"
                                    outlined
                                    hide
                                    v-model="form.date"/>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-select
                                    label="Type"
                                    :items="types"
                                    v-model="form.type"
                                    :rules=[isRequired]
                                    outlined
                                    dense
                                    hide-details="auto">
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-row v-if="form.type != 'ALL'">
                            <v-col>
                                <v-text-field
                                    label="Mimimum Amount"
                                    v-model="form.min_amount"
                                    :rules="[isNumeric]"
                                    outlined
                                    dense
                                    hide-details="auto">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-row no-gutters>
                        <v-col class="me-1">
                            <v-btn depressed color="primary" block @click="submit" :loading="loading">
                                search
                            </v-btn>
                        </v-col>
                        <v-col class="ms-1">
                            <v-btn text block @click="searchDialog = false">
                                cancel
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar.value" :color="snackbar.color">{{snackbar.text}}</v-snackbar>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import CustomersBalanceReportTable from './../../components/Sales/CustomersBalanceReportTable';
import { isRequired, isNumeric } from './../../utils/validations';
import { formatNumber } from 'accounting';
import PDatePicker from './../../components/common/PDatePicker.vue';
import moment from 'moment';

export default {
    name: "CustomersBalanceReportView",
    components: {
        CustomersBalanceReportTable,
        PDatePicker
    },
    data() {
        return {
            searchDialog: true,
            types: [
                { text: "All", value: "ALL" },
                { text: "Under Collection", value: "RECEIVABLE" },
                { text: "Unearned", value: "UNEARNED" },
            ],
            form: {
                date: moment().format("YYYY-MM-DD"),
                type: "ALL",
                min_amount: null
            },
            snackbar: {
                value: false,
                text: "",
                color: ""
            }
        }
    },
    computed: {
        ...mapGetters("sales/reports/customersBalance", [
            "loading", "params"
        ])
    },
    methods: {
        isRequired, isNumeric,
        formatNumber,
        ...mapActions("sales/reports/customersBalance", [
            "get", "updateParams"
        ]),
        submit() {
            if(!this.$refs.form.validate()) return;
            this.run();
        },
        run() {
            this.updateParams({...this.form}).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar = { value: true, color: "error", text: message }
            }).finally(() => this.searchDialog = false);
        }
    }
}
</script>

<style>

</style>